module.exports = __webpack_public_path__ + "static/media/watermarking-icon.de76a8ad.svg";